// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Email Notification Record ──
/**
 * Every status an email queue row can carry — the one list the queue service,
 * the admin list route's `status` filter and the admin page read, so a status
 * added to one is offered by all three (fix-sprint-20260816-2121).
 */
export const EMAIL_QUEUE_STATUSES = ['queued', 'sending', 'sent', 'failed', 'bounced'];
// ── Default Preference Values ──
export const DEFAULT_NOTIFICATION_PREFERENCES = {
    channels: {
        task_assigned: { platform: true, email: true },
        task_sla_approaching: { platform: true, email: true },
        task_overdue: { platform: true, email: true },
        task_completed: { platform: true, email: false },
        task_escalated: { platform: true, email: true },
        workflow_transition: { platform: true, email: false },
        approval_requested: { platform: true, email: true },
        comment_added: { platform: true, email: false },
        weekly_digest: { platform: false, email: true },
        sla_breach_report: { platform: true, email: true },
        system_alert: { platform: true, email: true },
        rights_request_received: { platform: true, email: true },
        acknowledgment_reminder: { platform: true, email: true },
        approval_expired: { platform: true, email: true },
        scheduled_export_delivered: { platform: false, email: true },
        cross_border_transfer_added: { platform: true, email: true },
    },
    quiet_hours_enabled: false,
    digest_frequency: 'weekly',
    watched_entities: [],
};
//# sourceMappingURL=notification.js.map